// Lightweight, localStorage-backed preferences: theme + desktop notifications.

const THEME_KEY = 'webTheme'; // 'light' | 'dark'
const NOTIF_KEY = 'webNotifications'; // '1' | '0'

export function getTheme() {
  return localStorage.getItem(THEME_KEY) || 'light';
}

export function applyTheme(theme = getTheme()) {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}

export function setTheme(theme) {
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
}

export function notificationsEnabled() {
  return localStorage.getItem(NOTIF_KEY) === '1';
}

export function setNotificationsEnabled(on) {
  localStorage.setItem(NOTIF_KEY, on ? '1' : '0');
}

// Ask the browser for permission and remember the choice.
export async function requestNotifications() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') {
    setNotificationsEnabled(true);
    return true;
  }
  const result = await Notification.requestPermission();
  const granted = result === 'granted';
  setNotificationsEnabled(granted);
  return granted;
}

// Show a desktop notification if enabled, permitted, and the tab is hidden.
export function notify(title, body) {
  if (!notificationsEnabled()) return;
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  if (!document.hidden) return;
  try {
    new Notification(title, { body });
  } catch {
    /* no-op */
  }
}
